import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles.css';
import { LanguageProvider } from './i18n/LanguageContext';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToHash from './components/ScrollToHash';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Contact from './pages/Contact';

import OfficeAutomation from './pages/products/OfficeAutomation';
import RicohSolutions from './pages/products/RicohSolutions';
import ITInfrastructure from './pages/products/ITInfrastructure';
import AudioVisual from './pages/products/AudioVisual';
import RetailSolutions from './pages/products/RetailSolutions';
import PrintingSupplies from './pages/products/PrintingSupplies';

import ManagedPrint from './pages/services/ManagedPrint';
import AmcSla from './pages/services/AmcSla';
import ManagedIT from './pages/services/ManagedIT';
import Cybersecurity from './pages/services/Cybersecurity';
import CloudServices from './pages/services/CloudServices';
import AvIntegration from './pages/services/AvIntegration';

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Header />
        <ScrollToHash />
        <main style={{ paddingTop: '68px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/products/office-automation" element={<OfficeAutomation />} />
            <Route path="/products/ricoh-solutions" element={<RicohSolutions />} />
            <Route path="/products/it-infrastructure" element={<ITInfrastructure />} />
            <Route path="/products/audio-visual" element={<AudioVisual />} />
            <Route path="/products/retail-solutions" element={<RetailSolutions />} />
            <Route path="/products/printing-supplies" element={<PrintingSupplies />} />

            <Route path="/services/managed-print" element={<ManagedPrint />} />
            <Route path="/services/amc-sla" element={<AmcSla />} />
            <Route path="/services/managed-it" element={<ManagedIT />} />
            <Route path="/services/cybersecurity" element={<Cybersecurity />} />
            <Route path="/services/cloud-services" element={<CloudServices />} />
            <Route path="/services/av-integration" element={<AvIntegration />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </LanguageProvider>
  );
}
